/** @format */
/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useState } from "react";

export default function usePlansPricingLanding() {
	const dataEssentials = [
		{ id: 1, type: "Essentials", properties: 20, code: "P20", price: "24.95" },
		{ id: 3, type: "Essentials", properties: 50, code: "P50", price: "43.95" },
		{ id: 5, type: "Essentials", properties: 100, code: "P100", price: "72.95" },
		{ id: 7, type: "Essentials", properties: 250, code: "P250", price: "120.95" },
		{ id: 9, type: "Essentials", properties: 500, code: "P500", price: "181.95" },
		{ id: 11, type: "Essentials", properties: 1000, code: "P1000", price: "241.95" },
		{ id: 13, type: "Essentials", properties: 2000, code: "P2000", price: "362.95" },
		{ id: 15, type: "Essentials", properties: 3000, code: "P3000", price: "483.95" },
		{ id: 17, type: "Essentials", properties: 4000, code: "P4000", price: "604.95" },
		{ id: 19, type: "Essentials", properties: 5000, code: "P5000", price: "725.95" },
		// {   id: 21, type: "Essentials", properties: 6000 ,code: "P6000", price: "846.95" },
		// {   id: 23, type: "Essentials", properties: 7000 ,code: "P7000", price: "967.95" },
		// {   id: 25, type: "Essentials", properties: 8000 ,code: "P8000", price: "1088.95" },
		// {   id: 27, type: "Essentials", properties: 9000 ,code: "P9000", price: "1209.95" },
		// {   id: 29, type: "Essentials", properties: 10000 ,code: "P10000", price: "1330.95" },
		// {   id: 31, type: "Essentials", properties: 11000 ,code: "P11000", price: "1451.95" },
		// {   id: 33, type: "Essentials", properties: 12000 ,code: "P12000", price: "1572.95" },
		// {   id: 35, type: "Essentials", properties: 13000 ,code: "P13000", price: "1693.95" },
		// {   id: 37, type: "Essentials", properties: 14000 ,code: "P14000", price: "1810.95" },
		// {   id: 39, type: "Essentials", properties: 15000 ,code: "P15000", price: "1931.95" },
		// {   id: 41, type: "Essentials", properties: 16000 ,code: "P16000", price: "2052.95" },
		// {   id: 43, type: "Essentials", properties: 17000 ,code: "P17000", price: "2173.95" },
		// {   id: 45, type: "Essentials", properties: 18000 ,code: "P18000", price: "2294.95" },
	];
	const dataPremium = [
		{ id: 2, type: "Premium", properties: 20, code: "P20", price: "56.95" },
		{ id: 4, type: "Premium", properties: 50, code: "P50", price: "75.95" },
		{ id: 6, type: "Premium", properties: 100, code: "P100", price: "126.95" },
		{ id: 8, type: "Premium", properties: 250, code: "P250", price: "207.95" },
		{ id: 10, type: "Premium", properties: 500, code: "P500", price: "290.95" },
		{ id: 12, type: "Premium", properties: 1000, code: "P1000", price: "405.95" },
		{ id: 14, type: "Premium", properties: 2000, code: "P2000", price: "581.95" },
		{ id: 16, type: "Premium", properties: 3000, code: "P3000", price: "757.95" },
		{ id: 18, type: "Premium", properties: 4000, code: "P4000", price: "933.95" },
		{ id: 20, type: "Premium", properties: 5000, code: "P5000", price: "1109.95" },
		// {   id: 22, type: "Premium", properties: 6000,code: "P6000", price: "1285.95" },
		// {   id: 24, type: "Premium", properties: 7000,code: "P7000", price: "1461.95" },
		// {   id: 26, type: "Premium", properties: 8000,code: "P8000", price: "1637.95" },
		// {   id: 28, type: "Premium", properties: 9000,code: "P9000", price: "1813.95" },
		// {   id: 30, type: "Premium", properties: 10000,code: "P10000", price: "1989.95" },
		// {   id: 32, type: "Premium", properties: 11000,code: "P11000", price: "2165.95" },
		// {   id: 34, type: "Premium", properties: 12000,code: "P12000", price: "2341.95" },
		// {   id: 36, type: "Premium", properties: 13000,code: "P13000", price: "2517.95" },
		// {   id: 38, type: "Premium", properties: 14000,code: "P14000", price: "2689.95" },
		// {   id: 40, type: "Premium", properties: 15000,code: "P15000", price: "2865.95" },
		// {   id: 42, type: "Premium", properties: 16000,code: "P16000", price: "3041.95" },
		// {   id: 44, type: "Premium", properties: 17000,code: "P17000", price: "3217.95" },
		// {   id: 46, type: "Premium", properties: 18000,code: "P18000", price: "3393.95" }
	];

	const [sliderValue, setSliderValue] = useState<any>(500);
	const [essentialsValue, setEssentialsValue] = useState<any>(dataEssentials[0]);
	const [premiumValue, setPremiumValue] = useState<any>(dataPremium[0]);

	const changeOptions = (e) => {
		setSliderValue(e);
	};

	const updateInfo = () => {
		setEssentialsValue(dataEssentials.find((item) => item.properties >= sliderValue));
		setPremiumValue(dataPremium.find((item) => item.properties >= sliderValue));
		let elemento: any = document.getElementById("custon-tooltip");
		if (elemento) elemento.textContent = `${sliderValue}`;
	};

	useEffect(() => {
		updateInfo();
	}, [sliderValue]);

	const initTooltip = () => {
		let elemento: any = document.getElementsByClassName("p-slider-handle");
		let div = document.createElement("div");
		div.id = "custon-tooltip";
		div.className = "tooltip-one";
		div.textContent = `${sliderValue}`;
		elemento[0].appendChild(div);
	};

	useEffect(() => {
		initTooltip();
		changeOptions(sliderValue);
	}, []);

	return {
		sliderValue,
		setSliderValue,
		changeOptions,
		essentialsValue,
		premiumValue,
	};
}
